// Shared validation helpers for SMP forms

export const isValidEmail = (email) => {
  if (!email || !email.trim()) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
};

export const isValidPhone = (phone) => {
  if (!phone || !phone.trim()) return false;
  // Accept various formats: (555) 123-4567, 555-123-4567, 5551234567, +1 555 123 4567
  const digits = phone.replace(/\D/g, "");
  return digits.length >= 7 && digits.length <= 15;
};

export const isNotEmpty = (val) => {
  return val !== null && val !== undefined && String(val).trim().length > 0;
};

export const isValidDate = (dateStr) => {
  if (!dateStr) return false;
  const d = new Date(dateStr + "T12:00:00");
  return !isNaN(d.getTime());
};

export const isPositiveNumber = (val) => {
  const n = Number(val);
  return !isNaN(n) && n > 0;
};

// Run a set of validation rules, returns error object
// rules: [{ field: "email", value: val, checks: [{ test: fn, message: "..." }] }]
export const validate = (rules) => {
  const errors = {};
  rules.forEach(({ field, value, checks }) => {
    for (const check of checks) {
      if (!check.test(value)) {
        errors[field] = check.message;
        break; // stop at first failure per field
      }
    }
  });
  return errors;
};

// Common check sets
export const required = (msg = "Required") => ({ test: isNotEmpty, message: msg });
export const emailFormat = (msg = "Invalid email format") => ({ test: isValidEmail, message: msg });
export const phoneFormat = (msg = "Invalid phone number") => ({ test: isValidPhone, message: msg });
export const positiveNum = (msg = "Must be a positive number") => ({ test: isPositiveNumber, message: msg });
export const validDate = (msg = "Invalid date") => ({ test: isValidDate, message: msg });
export const optionalEmail = (msg = "Invalid email format") => ({
  test: (v) => !v || !v.trim() || isValidEmail(v),
  message: msg
});
export const optionalPhone = (msg = "Invalid phone number") => ({
  test: (v) => !v || !v.trim() || isValidPhone(v),
  message: msg
});
